<template>
  <div style="height: 100%;">
    <el-row :gutter="20" class="container">
      <!-- 右边主要区 -->
      <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
        <!-- 右边头部搜索区 -->
        <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch"
                 label-width="110px">
          <!-- 组件名称 -->
          <el-form-item :label="columnInfo.name.label" prop="name">
            <el-input v-model="queryParams.param.name" placeholder="请输入内容" size="small" clearable></el-input>
          </el-form-item>
          <!-- 组件模板代码 -->
          <el-form-item :label="columnInfo.word.label" prop="word">
            <el-input v-model="queryParams.param.word" placeholder="请输入内容" size="small" clearable></el-input>
          </el-form-item>
          <!-- 组件类型 -->
          <el-form-item :label="columnInfo.type.label" prop="type">
            <enum-dict-select v-model="queryParams.param.type" module-name="data" dict-code="widgetType"
                              placeholder="请选择" size="small" clearable></enum-dict-select>
          </el-form-item>
          <!-- 组件备注 -->
          <el-form-item :label="columnInfo.comment.label" prop="comment">
            <el-input v-model="queryParams.param.comment" placeholder="请输入内容" size="small" clearable></el-input>
          </el-form-item>
          <!-- 是否默认 -->
          <el-form-item :label="columnInfo.isDefault.label" prop="isDefault">
            <enum-dict-select v-model="queryParams.param.isDefault" placeholder="请选择" module-name="data" size="small"
                              dict-code="binary"></enum-dict-select>
          </el-form-item>
          <!-- 状态 -->
          <el-form-item :label="columnInfo.state.label" prop="state">
            <enum-dict-select v-model="queryParams.param.state" placeholder="请选择" module-name="data" size="small"
                              dict-code="state"></enum-dict-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleTableSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 右边中部功能区 -->
        <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
          <el-col :span="1.5">
            <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                size="small"
                @click="clickAdd"
                v-permissionDisabled="'data:widget:create'"
            >新增
            </el-button>
          </el-col>
          <el-col :span="1.5">
            <excel-import-plus title="数据组件表	" module-name="data" table-name="widget"
                               :permission-code="'data:widget:import'"></excel-import-plus>
          </el-col>
          <el-col :span="1.5">
            <excel-export-plus file-name="数据组件表	" module-name="data" table-name="widget" :select-list="selectList"
                               :permission-code="'data:widget:export'"></excel-export-plus>
          </el-col>
          <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                              :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
        </el-row>
        <!-- 右边中部表格区 -->
        <div class="main">
          <div class="table">
            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                      @selection-change="handleSelectionChange" height="100%"
                      :header-cell-style="{background:'#ECF5FF'}">
              <el-table-column align="center" type="selection" width="55"/>
              <!-- 组件名称 -->
              <el-table-column align="center" prop="name" :label="columnInfo.name.label"
                               v-if="columnInfo.name.visible" width="230"></el-table-column>
              <!-- 组件模板代码 -->
              <el-table-column align="center" prop="word" :label="columnInfo.word.label" show-overflow-tooltip
                               width="355"
                               v-if="columnInfo.word.visible"></el-table-column>
              <!-- 组件类型 0：输入型组件 1：展示型组件 -->
              <el-table-column align="center" prop="type" :label="columnInfo.type.label"
                               v-if="columnInfo.type.visible">
                <template v-slot="scope">
                  <enum-dict-label v-model="scope.row.type" module-name="data" dict-code="widgetType"></enum-dict-label>
                </template>
              </el-table-column>
              <!-- 组件备注 -->
              <af-table-column align="center" prop="comment" :label="columnInfo.comment.label"
                               v-if="columnInfo.comment.visible"></af-table-column>
              <!-- 是否默认 -->
              <el-table-column align="center" prop="isDefault" :label="columnInfo.isDefault.label"
                               v-if="columnInfo.isDefault.visible">
                <template v-slot="scope">
                  <enum-dict-label v-model="scope.row.isDefault" module-name="data"
                                   dict-code="binary"></enum-dict-label>
                </template>
              </el-table-column>
              <!-- 状态 -->
              <el-table-column align="center" prop="state" :label="columnInfo.state.label"
                               v-if="columnInfo.state.visible">
                <template v-slot="scope">
                  <enum-dict-label v-model="scope.row.state" dict-code="state" module-name="data"
                                   show-tag></enum-dict-label>
                </template>
              </el-table-column>
              <!-- 操作列 -->
              <el-table-column align="center" label="操作" width="255" fixed="right">
                <template v-slot="scope">
                  <el-button @click="clickEdit(scope.row)" type="primary" size="mini"
                             v-permissionDisabled="'data:widget:update'">编辑
                  </el-button>
                  <el-button @click="clickDel(scope.row)" type="danger" size="mini"
                             v-permissionDisabled="'data:widget:remove'">删除
                  </el-button>
                  <table-more-button :row="scope.row" :button-props="moreButtonProps"
                                     @handleCommand="handleCommand"></table-more-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 右边底部分页区 -->
        <div style="height: 40px;margin-bottom: 0.1rem;">
          <pagination-plus :totalCount="totalCount"
                           :param="queryParams"
                           :pageSizes="pageSizes"
                           :selectList="selectList"
                           module-name="data"
                           table-name="widget"
                           :del-all-permission-code="'data:widget:removes'"
                           :state-permission-code="'data:widget:state'"
                           @handleTableRefresh="handleTableSearch"/>
        </div>
      </el-col>
    </el-row>
    <!-- 弹出层组件 -->
    <WidgetForm/>
  </div>
</template>

<script>
/**
 * 数据组件表  主页面 （与自定义组件之间请遵循MVVM架构）
 * @author PeterLee
 * @since 2022-07-21
 */
import WidgetForm from "./WidgetForm"
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  components: {
    //表单弹出组件
    WidgetForm
  },
  data() {
    return {
      //每页条数选项（分页控件）
      pageSizes: [10, 20, 40, 80],
      //批量操作选中list（分页控件）
      selectList: [],
      //展示搜索区（right-toolbar）
      showSearch: false,
      //导出loading
      exportLoading: false,
    }
  },
  computed: {
    ...mapState({
      //表格数据
      tableData: state => state.data.widget.tableData,
      //下拉选项
      options: state => state.data.widget.options,
      //共有数据条数（分页控件）
      totalCount: state => state.data.widget.totalCount,
      //列信息
      columnInfo: state => state.data.widget.columnInfo,
      //查询参数
      queryParams: state => state.data.widget.queryParams,
      //时间范围
      dateRange: state => state.data.widget.dateRange,
      //更多按钮信息
      moreButtonProps: state => state.data.widget.moreButtonProps,
    })
  },
  //生命周期create函数
  created() {
    //创建时获取所有权限数据（分页查询）
    this.handleTableSearch();
    //获取OptionList
    this.getOptionList();
    // 浏览器运行提示
    // const userAgent = navigator.userAgent.toLowerCase();
    // if (userAgent.indexOf('electron/') === -1){
    //   this.$message.warning("注意：为确保正常使用\"数字开发工具\"，请使用electron运行!")
    // }
  },
  methods: {
    ...mapMutations({
      clickEdit: 'data/widget/clickEdit',
      clickAdd: 'data/widget/clickAdd',
    }),
    ...mapActions({
      clickDel: 'data/widget/handleDel',
      handleTableSearch: 'data/widget/handleTableSearch',
      getOptionList: 'data/widget/getOptionList',
    }),
    /** 重置按钮点击（搜索区） */
    clickReset() {
      for (let key of Object.keys(this.dateRange)) {
        this.dateRange[key] = []
      }
      this.$refs['queryForm'].resetFields();
      this.handleTableSearch();
    },
    /** 处理选择改变（表格区） */
    handleSelectionChange(selectList) {
      this.selectList = selectList;
    },
    /** 重新计算表格（按钮区） */
    redoTableLayout() {
      //数据加载完成后执行
      this.$nextTick(() => {
        //表格重新渲染
        this.$refs.multipleTable.doLayout();
      });
    },
    /** 更多按钮方法处理（按钮区） */
    handleCommand(command, row) {
      // console.log(command)
      // console.log(row)
    }
  }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/style/index.less');

::v-deep .el-form-item {
  margin-bottom: 18px;
}
</style>
